import { Component } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { NgForm } from '@angular/forms';
import {AngularFireDatabase, FirebaseListObservable, FirebaseObjectObservable} from 'angularfire2/database';

@Component({
  selector: 'app-view-student',
  templateUrl: './view-student.component.html',
  styleUrls: ['./view-student.component.scss']
})
export class ViewStudentComponent {

menuDetails:any={};
menuItemsdata: FirebaseObjectObservable<any>;
  constructor(private route: ActivatedRoute,  public router: Router, public af: AngularFireDatabase) {
  	 	 	this.route.params.map(params => params['id']).subscribe((Id) => {
  	 	if(Id != null) {
        this.menuItemsdata = this.af.object('/menuItems/' + Id);
        this.menuItemsdata.subscribe(
        (response) => { 
        	this.menuDetails = response;
        	this.af.object('/categories/' + response.category).subscribe((res)=>{
        		this.menuDetails.categoryTitle = res.title;
        	})
         }
      )
          }
       });
  }

}



// WEBPACK FOOTER //
// /Users/sooweeseng/Documents/Ionic Apps/FoonYew2_Backend_ok_version/webapp/src/app/routes/restaurant/students/view-student/view-student.component.ts